import { useMemo } from 'react';
import { booksFeed } from '@battleops/shared';
import { useLocalDoc } from './useLocal';

/**
 * The books' Sales and Finance feed (docs/plans/scores.md S4 — opsSales/now, opsFinance/now), normalised by shared
 * booksFeed: { sales, finance }, each null until the books have published it and it has synced here (owners, and a
 * member with a grant on the Sales / Finance department). Department goals (sales:* · finance:*) count from it.
 */
export function useBooksFeed() {
  const sales = useLocalDoc('sales', 'now');
  const finance = useLocalDoc('finance', 'now');
  return useMemo(() => booksFeed({ sales, finance }), [sales, finance]);
}
